import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AdLicenseApplicationStateDto,
  AdLicenseMutationResponseDto,
  CreateAdLicenseRequestDto,
} from '../../common/general-types/ad-license.dto';

/** Brand-side calls for one-off Ad Licenses on approved videos. */
@Injectable({
  providedIn: 'root'
})
export class AdLicenseService {
  private http = inject(HttpClient);

  private readonly baseUrl = `${environment.shout_api.url}/brief-ad-licenses`;

  /** The price quote for this application plus the latest licence per video. */
  getForApplication(briefApplicationId: string): Observable<AdLicenseApplicationStateDto> {
    return this.http.get<AdLicenseApplicationStateDto>(`${this.baseUrl}/application/${briefApplicationId}`);
  }

  /** Reserves the price from the brand wallet and sends the request to the creator. */
  request(body: CreateAdLicenseRequestDto): Observable<AdLicenseMutationResponseDto> {
    return this.http.post<AdLicenseMutationResponseDto>(this.baseUrl, body);
  }

  /** Withdraws a pending request; the reservation goes back to the wallet. */
  cancel(licenseId: string): Observable<AdLicenseMutationResponseDto> {
    return this.http.post<AdLicenseMutationResponseDto>(`${this.baseUrl}/${licenseId}/cancel`, {});
  }
}
